import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyAUBQeyUzBUJgRXgPiq8veuXAq65I05H6k",
  authDomain: "dentistry-501f7.firebaseapp.com",
  projectId: "dentistry-501f7",
  storageBucket: "dentistry-501f7.firebasestorage.app",
  messagingSenderId: "814809277382",
  appId: "1:814809277382:web:a4ddf4f40d8bef79a788c7",
};

const app = initializeApp(firebaseConfig);

export default app;
